import {
  message, Space, notification, Select, Alert, Switch } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  MensajeError,
  ModalItem,
  ButtonItem,
  Form,
  FormItem,
  InputItem,
  SelectItem,
  ErrorItem,
  NotificacionMovimientosInventario,
} from "../../../../Components/Items";
import ModalCancelarPdf from "./ModalCancelarPdf/ModalCancelarPdf";

const { Option } = Select;

class CancelarVenta extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    modalPdfVisible: false, 
    ventaId: null, 
  };

  onFinishFailed(e) {
    ErrorItem(e);
  }

  onFinish(values) {
    const cargaHistorica = !!this.props.cargaHistorica;
    this.setState({ loading: true });
    axios
      .post(
        "ventas/cancelarVenta",
        {
          ...values,
          // El motivo 01-04 es del catalogo de cancelacion del SAT y aqui no aplica, porque el
          // CFDI no se cancela. Se guarda una nota interna: textoMotivoCancelacion solo acepta
          // codigos de dos digitos, asi que ningun acuse la imprime como motivo fiscal.
          ...(cargaHistorica ? { motivo: "Cancelacion solo en el sistema (carga historica)", folioSustitucion: undefined } : {}),
          ventaId: this.props.id,
          empresaId: this.props.empresaId,
          modalCancelacionTimbre: this.props.modalCancelacionTimbre,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2 ) {
          message.success(res.data.message);
          NotificacionMovimientosInventario(res.data.movimientosIds);
          // Una cancelacion solo en el sistema no genera acuse del SAT: no hay PDF que mostrar.
          if (cargaHistorica) {
            this.props.cerrarCancelarVenta();
          } else {
            this.mostrarModalPdf();
          }
        } else if (res.data.success === 3) {
          // Venta ya cancelada
          notification.warning({
            message: "Venta ya cancelada",
            description: res.data.message,
            duration: 6,
          });
        } else if (res.data.success === 1) {
          MensajeError({
            message: res.data.errorTimbrado?.titulo || "No se pudo cancelar la venta",
            description: res.data.errorTimbrado?.mensaje || res.data.message,
            detalleTecnico: res.data.errorTimbrado?.detalleTecnico,
          });
        } else {
          message.error("Sucedió un error y no se pudo cancelar");
        }
        // Optional chaining: en la carga historica ya se cerro el modal y el form puede estar desmontado.
        this.formRef.current?.resetFields();
        this.setState({ loading: false });
      });
  }

  mostrarModalPdf() {
    this.setState({
      modalPdfVisible: true, // Mostrar ModalCancelarPdf
      ventaId: this.props.id, // Almacenar el ID de la venta para el modal de PDF
    });
  }

  cerrarModalPdf = () => {
    this.setState({ modalPdfVisible: false }); // Cerrar ModalCancelarPdf
    this.props.cerrarCancelarVenta(); // Cerrar el modal principal
  };

  regresar = () => {
    this.props.cerrarCancelarVenta(); // Solo cerrar el modal principal
  };

  render() {
    const cargaHistorica = !!this.props.cargaHistorica;
    return (
      <>
        <ModalItem
          title="Cancelar Venta"
          visible={this.props.visible}
          spinning={this.state.loading}
          onCancel={this.regresar} // Cerrar modal al presionar "Regresar"
          paddingTop
        >
          <Form
            ref={this.formRef}
            name="cancelarVenta"
            layout
            width={700}
            onFinish={this.onFinish.bind(this)}
            onFinishFailed={this.onFinishFailed}
          >
            {cargaHistorica ? (
              // Carga historica: el CFDI se emitio fuera del ERP y debe seguir vigente, asi que
              // no se piden los campos del catalogo de cancelacion del SAT.
              <>
                <Alert
                  type="warning"
                  showIcon
                  style={{ marginBottom: 15 }}
                  message="Carga historica"
                  description="Esta venta se cancelara unicamente en el sistema. El CFDI no se cancelara en el SAT."
                />
                <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 10 }}>
                  <Switch checked disabled />
                  <span>No cancelar el CFDI en el SAT</span>
                </div>
              </>
            ) : (
              <>
                <FormItem
                  label="Motivo"
                  name="motivo"
                  required
                  pattern
                  margin
                  max={200}
                >
                  <SelectItem placeholder="Motivo">
                    <Option value="01">
                      01 - Comprobante emitido con errores con relación.
                    </Option>
                    <Option value="02">
                      02 - Comprobante emitido con errores sin relación.
                    </Option>
                    <Option value="03">03 - No se llevó a cabo la operación.</Option>
                    <Option value="04">
                      04 - Operación nominativa relacionada en una factura global.
                    </Option>
                  </SelectItem>
                </FormItem>
                <FormItem
                  label="Folio Sustitución"
                  name="folioSustitucion"
                  pattern
                  margin
                  max={200}
                >
                  <InputItem placeholder="Folio de Sustitución" />
                </FormItem>
              </>
            )}
            <div
              style={{
                display: "flex",
                justifyContent: "right",
                marginTop: 20,
                marginBottom: 10,
              }}
            >
              <Space>
                <ButtonItem
                  type="primary"
                  htmlType="submit"
                  style={{ display: "block", margin: "0 0 0 auto" }}
                >
                  Cancelar Venta
                </ButtonItem>
                <ButtonItem
                  type="primary"
                  danger
                  onClick={this.regresar} // Nueva función para cerrar el modal principal
                  style={{ display: "block", margin: "0 0 0 auto" }}
                >
                  Regresar
                </ButtonItem>
              </Space>
            </div>
          </Form>
        </ModalItem>
        <ModalCancelarPdf
          visible={this.state.modalPdfVisible}
          ventaId={this.state.ventaId} // Pasar el ID como prop
          onCancel={this.cerrarModalPdf}
          cerrarModalPdf={this.cerrarModalPdf}
        />
      </>
    );
  }
}


const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(CancelarVenta);
